import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Divider, Badge, Tag, Drawer, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Link } from 'react-router-dom';
import UserHierarchy from './user_hierarchy';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showSuccessInNotification, formatMoney } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import { COLORS } from '../../theme';

const queryString = require('query-string');



const user_cols = ({ onEditPressed }) => [
    {
        title: "Username",
        dataIndex: "username",
        key: 'username',
        className:'bold-cell'
    }, {
        title: "Name",
        dataIndex: "name",
        key: 'name'
    }, {
        title: "Phone",
        dataIndex: "phone",
        key: 'phone'
    }, {
        title: "Email",
        dataIndex: "email",
        key: 'email'
    },
    {
        title: "Role(s)",
        dataIndex: "roles",
        render: (roles = []) => {
            return <span>
                {roles.map((role_id, index) => <Tag key={index} color={COLORS.primary}>{role_id}</Tag>)}
            </span>
        }

    },
    {
        title: "Hierarchy",
        // dataIndex:'hierarchy',
        key: 'hierarchy',
        render: (data) => {
            let hierarchy = (data.__references__ && data.__references__.hierarchy) || {};
            return hierarchy.name
        }
    },

    {
        title: "Status",
        dataIndex: "disabled",
        key: 'disabled',
        render: (disabled) => {
            return <Badge
                status={disabled
                    ? 'error'
                    : 'success'}
                text={disabled
                    ? "Disabled"
                    : "Active"} />
        }
    }, {
        title: "",
        dataIndex: "id",
        key: 'id',
        render: (id, data) => {
            return <span>
                <Button
                    type='link'
                    onClick={() => {
                        typeof onEditPressed === 'function' && onEditPressed(data)
                    }}
                    style={{
                        padding: 0
                    }}>Edit</Button>
                <Divider type='vertical' style={{ marginLeft: 4, marginRight: 4 }} />
                <Link to={`/settings/users/${id}`}>
                    <Button
                        type='link'
                        style={{
                            padding: 0
                        }}>View</Button>
                </Link>
                <Divider type='vertical' style={{ marginLeft: 4, marginRight: 4 }} />
                <Link to={`/settings/logs/users?user_id=${id}`}>
                    <Button
                        type='link'
                        style={{
                            padding: 0
                        }}>Activity</Button>
                </Link>

            </span>
        }
    }
]

const user_fields = [
    {
        index: 'username',
        name: "Username",
        type: 'text'
    }, {
        index: 'password',
        name: "Password",
        type: 'password',
        show_update: false
    }, {
        index: 'name',
        name: "Full Name",
        type: 'text'
    }, {
        index: 'email',
        name: "Email",
        type: 'text'
    }, {
        index: 'phone',
        name: "Phone No.",
        type: 'text'
    },
    {
        index: 'roles',
        name: "User Role(s)",
        filterable: true,
        mode: 'multiple',
        type: 'select',
        options: []
    }, {
        index: 'hierarchy',
        name: "Hierarchy",
        type: 'networkselect',
        url: '/user-hierarchy',
        filterable: true
        // help_text:"1 For Higher Post"
    }
];
class UserList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            edit_id: null,
            form_data: {},
            form_visibility: false,
            schema: user_fields,
            hierarchy_view: false,
            filter_query: {}
        };

        this.list_users = RESTExecutor
            .list()
            .config({ label: 'user_list', params: { per_page: 100 } })
            .connect(props.domains.users);



        this.post_user = RESTExecutor
            .post()
            .config({ label: 'user_list' })
            .callbacks((success) => {
                this.setState({ edit_id: null, form_data: {}, form_visibility: false });
                this.list_users.execute()
                showSuccessInNotification(success)
            },(error)=>{

            })
            .connect(props.domains.users);

        this.patch_user = RESTExecutor
            .patch()
            .config({ label: 'user_detail' })
            .callbacks((success) => {
                this.setState({ edit_id: null, form_data: {}, form_visibility: false });
                showSuccessInNotification(success)
                this.list_users.execute()
            })
            .connect(props.domains.users);

        this.list_roles = RESTExecutor
            .list()
            .config({ label: 'user_roles' })
            .callbacks((success) => {
                let roles_options = [];
                success
                    .result
                    .rows
                    .map((role) => {
                        roles_options.push({ text: role.id, value: role.id })
                    });

                let schema = this.state.schema;
                schema.map((item) => {
                    if (item.index === 'roles') {
                        item.options = roles_options
                    }
                });

                this.setState({ schema: schema })
            })
            .connect(props.domains.users);

        this.delay_search = new NetworkDelaySearch();

    };

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    handlePostPatch = (data) => {
        console.log("handle", data);
        if (this.state.edit_id) {
            this
                .patch_user
                .forId(this.state.edit_id)
                .execute(data);

        } else {
            this
                .post_user
                .execute(data);
        }
    }
    render() {
        let list_users_resp = this
            .list_users
            .response();

        let post_user_resp = this
            .post_user
            .response();
        let patch_user_resp = this
            .patch_user
            .response();
        

        let list_users_data = list_users_resp.result || {};
        let rowsData = list_users_data.rows || [];
        let rowsMeta = list_users_resp.meta || {};

        const { schema, filter_query } = this.state;

        return (

            <div>
                <BasicHeader no_back title="Users"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New User"
                            onClick={() => {
                                this.setState({ edit_id: null, form_data: {}, form_visibility: true })
                            }}

                        />,
                        <TransparentButton
                            label="Hierarchy"
                            hint="View User Hierarchy"
                            onClick={() => {
                                this.setState({ hierarchy_view: true })
                            }}
                        />,
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
                         <Input.Search
                                        placeholder="Search For"
                                        style={{
                                        }}
                                        autoFocus
                                        value={filter_query.query}
                                        onChange={(e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                                                callback: () => {

                                                    this.delay_search.onSearch(() => {
                                                        this.props.history.push({
                                                            search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                        })
                                                    })

                                                }
                                            })
                                        }} />
                    </div>
                </div>

                <ErrorWrapper
                    error={list_users_resp}
                    onReload={() => {
                        this.list_users.execute()
                    }}
                >
                    <div
                        className='default-card'
                        style={{
                            padding: 0
                        }}>
                        <Table
                            columns={user_cols({
                                onEditPressed: (data) => {
                                    this.setState({ form_visibility: true, form_data: data, edit_id: data.id })
                                }
                            })}
                            scroll={{ x: true }}
                            dataSource={rowsData}
                            loading={list_users_resp.fetching}
                            className='main-table '
                            size='small'
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                pageSize: (rowsMeta && rowsMeta.requested_count),
                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}
                            rowKey={(record) => record.id} />


                      
                    </div>
                </ErrorWrapper>
                <PopUpForm
                    title="User"
                    forCreate={this.state.edit_id
                        ? false
                        : true}
                    initialData={this.state.form_data}
                    fields={schema}
                    open={this.state.form_visibility}
                    networkState={this.state.edit_id
                        ? patch_user_resp
                        : post_user_resp}
                    onClose={() => {
                        this.setState({ form_visibility: false, form_data: {}, edit_id: null })
                    }}
                    onSubmit={(data) => {
                        this.handlePostPatch(data);
                    }} />

<Drawer
                            title={<Title level={3} style={{ margin: 0 }}>User Hierarchy</Title>}
                            placement="right"
                            closable={false}
                            width='50%'
                            destroyOnClose
                            onClose={() => {
                                this.setState({
                                    hierarchy_view: false,
                                })
                            }}
                            visible={this.state.hierarchy_view}
                        >
                            <UserHierarchy />
                        </Drawer>
            </div>
        );
    }
    componentDidMount() {

        overrideHeaderTitle("Users");
        overrideHeaderBack(null);

        this.list_roles.execute();
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_users.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })

    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_users.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(UserList, "users");
